let API = {
  api: {
    login: "/member/login", //登录
    home: "", //首页
    meeting_list: "/ac1/conference/list", //会议列表
    setPublicStatus: "/ac1/conference/setPublicStatus ", //我的会议(发布)(暂停报名)
    address: "/ac1/region/all", //三级联动  获取地区
    meetsave: "/ac1/conference/save", //新建会议保存(编辑会议保存)
    meet_xq: "/ac1/conference/detail", //会议详情
    pin_meetlist: "/ac1/conference/paralle", //平行会议列表
    meet_set: "/ac1/conference/conferenceDetail", //会议详情(编辑会议)
    pay_set: "/ac1/conference/chargeDetail", //收费设置
    ticket_set: "/ac1/ticket/detail", //门票详情
    del_ticket: "/ac1/ticket/del", //删除门票
    ticket_save: "/ac1/ticket/save", //票种保存
    hotel_get: "/ac1/conference/depar/hotel", //获取酒店列表
    hotel_save: "/ac1/conference/hotel/save", //新建房型保存
    add_hotel: "/ac1/conference/confeInHotel/add", //添加新酒店
    del_hotel: "/ac1/conference/confeInHotel/del", //住宿删除
    eat_list: "/ac1/conference/depar/repast", //就餐列表
    del_eat: "/ac1/conference/confeInRepast/del", //删除就餐
    add_eat: "/ac1/conference/confeInRepast/add", //添加就餐
    eat_save: "/ac1/conference/repast/save", //就餐保存
    signup_list: "/ac1/enroll/field/detail", //报名设置列表
    del_signup: "/ac1/enroll/field/del", //报名设置删除
    guest_list: "/ac1/conference/guest/guestList", //嘉宾列表
    add_guest: "/ac1/guest/addMore", //添加嘉宾
    father_column: "/ac1/conference/column/parentColumn", //父级栏目
    video_list: "/ac1/conferece/video/list", //获取视频
    column_list: "/ac1/conference/column/conferenceList", //栏目列表
    colum_set: "/ac1/conference/column/detail", //栏目详情
    basse_img: "/ac1/conference/uploadBase64", //富文本上传图片
    registration: "/ac1/enroll/field/detail", //报名详情
    registration_save: "/ac1/enroll/field/save", //报名设置提交
    lan_mu: "/ac1/conference/column/detail", //栏目详情
    lan_del: "/ac1/conference/column/del", //栏目删除
    lan_save: "/ac1/conference/column/save", //栏目保存
    mechanism: "/ac1/template/list", //机构模板
    mechanism_xq: "/ac1/conference/share/detail", // 分享设置详情
    mechanism_save: "/ac1/conference/share/info", //分享设置保存
    up_baimg: "/ac1/SaveFile/base64", //上传base64图片
    city: "/ac1/region/all", //获取地区
    cover_img: "/ac1/icon/upload", //上传图片
    fujianupload: "/ac1/upload/oneFile", //上传附件
    ziliaouoload: "/ac1/conference/column/upload", //上传资料
    fuwenbenimg: "/ac1/conference/uploadBase64", //富文本上传图片
    removequanxian: "/ac1/conference/ConfShareAuth/del", //删除权限
    okfenpei: "/ac1/conference/ConfShareAuth/add", //确定分配权限
    fenxiangicon: "/ac1/icon/lsit", //分享页图标
    jigoutree: "/ac1/conference/team/depTree", ///*普通机构，部门树型列表二级联动*/
    peoplequanxian: "/ac1/conference/ConfShareAuth/memberLists", //用户权限
    allquanxian: "/ac1/conference/ConfShareAuth/authList", //全部用户权限
    /* 推出登录旁的机构 */
    listjigou: "/ac1/conference/team/memberTeam", //获取机构列表
    changejigou: "/ac1/conference/team/modifyTeamDep", //确定切换机构
    /* 资讯接口 */
    selectlist: "/ac1/conference/started", //渲染会议select
    editall: "/ac1/conference/news/detail", //编辑详情
    zixunsave: "/ac1/conference/news/save", //保存资讯
    zixinlists: "/ac1/conference/news/list", //资讯列表
    removezixun: "/ac1/conference/news/del", //删除资讯
    /* 登录接口 */
    loginurl: "/ac1/conference/loginJump", //获取登录跳转地址
    loginmations: "/ac1/conference/memberInfo", //获取用户信息
    /* 会议详情 */
    guanzuman: "/ac1/conference/memberList", //关注用户
    meetinformation: "/ac1/conference/detail", //会议信息内容
    /* 会议列表 */
    fenxianglist: "/ac1/conference/ConfShareAuth/conferenceList", //分享会议
    fabu: "/ac1/conference/setPublicStatus", //发布，暂停发布，继续发布
    savefenxaing: "/ac1/conference/ConfSubject/save", //专题提交
    esitfenxiang: "/ac1/conference/ConfSubject/detail", //编辑专题
    quxiaomeet: "/ac1/conference/ConfSubject/delReConference", //取消关联会议
    baocunmeet: "/ac1/conference/ConfSubject/reConference", //保存关联会议
    guanlianlists: "/ac1/conference/ConfSubject/reConferenceList", //关联会议列表
    zhuantilist: "/ac1/conference/ConfSubject/lists", //专题列表
    /* 订单 */
    officepay: "/ac1/conference/offlinePay", //汇款
    removepay: "/ac1/conference/refundSuccess", //退款，拒绝退款
    dingdanlist:"/ac1/conference/orderDetail",//订单列表

    /*20210823*/
    getHotel:'/ac1/conference/hotel/releva',//会议关联酒店
    deleteOrderItem:'/ac1/conference/order/delOrderItem',//删除订单详情会议信息
    deleteOrderHotel:'/ac1/conference/order/delOrderHotel',//删除订单详情酒店信息
    editOrderHotel:'/ac1/conference/order/editOrderHotel',//编辑订单详情酒店信息
    addOrderHotel:'/ac1/conference/order/addOrderHotel',//添加订单详情酒店信息
    reorder:'/ac1/conference/admin/reorder',//重新下单
    sendMsg:'/ac1/conference/seat/sendMsg',//发送座位信息
    addExcel:'/ac1/conference/order/addExcel',//导入生成订单的excel
    delInvoice:'/ac1/conference/admin/invoiceCancel',//取消发票申请
    invoiceToPush:'/ac1/conference/admin/invoiceToPush',//重新推送发票
    pishuDepList:'/ac1/conference/admin/pishuDepList',//皮书课题组列表
    editDep:'/ac1/conference/admin/editDep',//编辑课题组
    offlineToWaiting:'/ac1/conference/admin/offlineToWaiting',//将线下支付状态修改为待支付
    addRefund:'/ac1/conference/admin/addRefund',//后台申请退款

    editenroll: '/ac1/conference/editenroll', // 修改报名用户基础信息
    operationLog: '/ac1/conference/ordereditlog', // 订单修改操作记录

    saverefundtime: '/ac1/conference/saverefundtime', // 可退款截止时间
    membermark: '/ac1/conference/membermark', // 更新报名用户标记
  }
};
export default {
  API: API
};
